import * as yup from 'yup';

export const BuildingAddValidation = yup.object({
    buildingName: yup.string().required().min(3).max(25),
  managerId: yup.string().required(),
  locationId: yup.string().required(),
 

});
